import { render } from "./OapCard.vue?vue&type=template&id=b754e3fe&scoped=true"
import script from "./OapCard.vue?vue&type=script&lang=js"
export * from "./OapCard.vue?vue&type=script&lang=js"

import "./OapCard.vue?vue&type=style&index=0&id=b754e3fe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b754e3fe"]])

export default __exports__